// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Paper,
//   MenuItem,
//   CircularProgress
// } from '@mui/material';

// const countiesData = [
//   {
//     name: 'Nairobi',
//     subcounties: [
//       { name: 'Westlands', locations: ['Parklands', 'Kangemi', 'Mountain View'] },
//       { name: 'Dagoretti North', locations: ['Kilimani', 'Kawangware', 'Riruta'] },
//     ],
//   },
//   {
//     name: 'Mombasa',
//     subcounties: [
//       { name: 'Changamwe', locations: ['Port Reitz', 'Miritini', 'Chaani'] },
//       { name: 'Likoni', locations: ['Shika Adabu', 'Mtongwe', 'Likoni'] },
//     ],
//   },
//   {
//     name: 'Kwale',
//     subcounties: [
//       { name: 'Matuga', locations: ['Mwavumbo', 'Kikoneni', 'Tsimba Golini'] },
//       { name: 'Msambweni', locations: ['Gombato Bongwe', 'Ukunda', 'Kinondo'] },
//     ],
//   },
//   {
//     name: 'Kilifi',
//     subcounties: [
//       { name: 'Kilifi North', locations: ['Tezo', 'Matsangoni', 'Kikambala'] },
//       { name: 'Kilifi South', locations: ['Shimo la Tewa', 'Takaungu', 'Mtwapa'] },
//     ],
//   },
//   {
//     name: 'Tana River',
//     subcounties: [
//       { name: 'Garsen', locations: ['Kipini', 'Kipini East', 'Chewani'] },
//       { name: 'Galole', locations: ['Sala', 'Kinakomba', 'Mikinduni'] },
//     ],
//   },
//   // Add more counties as needed
// ];

// const InstitutionSignup = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     schoolName: '',
//     schoolCode: '',
//     county: '',
//     subcounty: '',
//     location: '',
//     village: '',
//     address: '',
//     phoneNumber: '',
//     email: '',
//     website: ''
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError('');

//     try {
//       const response = await axios.post('https://kidsm.vercel.app/api/schools/register', formData);
//       if (response.data) {
//         alert('School registered successfully! Please check your email to activate your account.');
//         navigate('/login');
//       }
//     } catch (error) {
//       setError(error.response?.data?.message || 'Registration failed. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const availableSubcounties = countiesData.find(c => c.name === formData.county)?.subcounties || [];
//   const availableLocations = availableSubcounties.find(sc => sc.name === formData.subcounty)?.locations || [];

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
//         <Typography variant="h4" component="h1" gutterBottom align="center">
//           School Registration
//         </Typography>
        
//         {error && (
//           <Typography color="error" align="center" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//         )}

//         <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//           <TextField
//             fullWidth
//             label="School Name"
//             name="schoolName"
//             value={formData.schoolName}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="School Code"
//             name="schoolCode"
//             value={formData.schoolCode}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             select
//             fullWidth
//             label="County"
//             name="county"
//             value={formData.county}
//             onChange={handleChange}
//             margin="normal"
//             required
//           >
//             <MenuItem value="">Select County</MenuItem>
//             {countiesData.map((county) => (
//               <MenuItem key={county.name} value={county.name}>
//                 {county.name}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             select
//             fullWidth
//             label="Subcounty"
//             name="subcounty"
//             value={formData.subcounty}
//             onChange={handleChange}
//             margin="normal"
//             required
//             disabled={!formData.county}
//           >
//             <MenuItem value="">Select Subcounty</MenuItem>
//             {availableSubcounties.map((subcounty) => (
//               <MenuItem key={subcounty.name} value={subcounty.name}>
//                 {subcounty.name}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             select
//             fullWidth
//             label="Location"
//             name="location"
//             value={formData.location}
//             onChange={handleChange}
//             margin="normal"
//             required
//             disabled={!formData.subcounty}
//           >
//             <MenuItem value="">Select Location</MenuItem>
//             {availableLocations.map((location) => (
//               <MenuItem key={location} value={location}>
//                 {location}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             fullWidth
//             label="Village"
//             name="village"
//             value={formData.village}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Address"
//             name="address"
//             value={formData.address}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Official Phone Number"
//             name="phoneNumber"
//             value={formData.phoneNumber}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="Official Email Address"
//             name="email"
//             type="email"
//             value={formData.email}
//             onChange={handleChange}
//             margin="normal"
//             required
//           />

//           <TextField
//             fullWidth
//             label="School Website (Optional)"
//             name="website"
//             value={formData.website}
//             onChange={handleChange}
//             margin="normal"
//           />

//           <Button
//             fullWidth
//             variant="contained"
//             color="primary"
//             type="submit"
//             disabled={isLoading}
//             sx={{ mt: 3, mb: 2, height: '48px' }}
//           >
//             {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register'}
//           </Button>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default InstitutionSignup;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

// Counties, Sub-counties, and Locations Data
const countiesData = [
  {
    name: 'Nairobi',
    subcounties: [
      {
        name: 'Westlands',
        locations: [
          'Parklands',
          'Kangemi',
          'Mountain View',
          'Kilimani',
          'Loresho',
          'Kitisuru',
          'Highridge',
          'Spring Valley',
          'Lower Kabete',
        ],
      },
      {
        name: 'Dagoretti North',
        locations: [
          'Kilimani',
          'Kawangware',
          'Riruta',
          'Waithaka',
          'Gatina',
          'Kileleshwa',
        ],
      },
      {
        name: 'Dagoretti South',
        locations: [
          'Ngando',
          'Kinyanjui',
          'Mutuini',
          'Uthiru/Ruthimitu',
          'Ngei',
        ],
      },
      {
        name: 'Langata',
        locations: [
          'Karen',
          'Nairobi West',
          'South C',
          'Kenyatta/Golf Course',
          'Mugumo-ini',
        ],
      },
      {
        name: 'Kibra',
        locations: [
          'Laini Saba',
          'Makina',
          'Lindi',
          "Sarang'ombe",
          'Woodley/Kenyatta Golf Course',
        ],
      },
      {
        name: 'Roysambu',
        locations: [
          'Githurai',
          'Kahawa West',
          'Zimmerman',
          'Kasarani',
          'Clay City',
        ],
      },
      {
        name: 'Kasarani',
        locations: ['Roysambu', 'Mwiki', 'Kanyonyo', 'Njiru', 'Ruai'],
      },
      {
        name: 'Embakasi South',
        locations: [
          'Imara Daima',
          'Kwa Njenga',
          'Pipeline',
          'Mukuru Kwa Reuben',
          'Savanna',
        ],
      },
      {
        name: 'Embakasi North',
        locations: ['Umoja', 'Kayole', 'Komarock', 'Dandora'],
      },
      {
        name: 'Embakasi Central',
        locations: [
          'Matopeni/Spring Valley',
          'Dandora Phase IV',
          'Savanna',
          'Kayole North',
          'Kayole South',
        ],
      },
      {
        name: 'Makadara',
        locations: [
          'Eastleigh North',
          'Eastleigh South',
          'Harambee',
          'Kaloleni',
          'Viwandani',
        ],
      },
      {
        name: 'Kamukunji',
        locations: [
          'Pangani',
          'Shauri Moyo',
          'California',
          'Nairobi Central',
          'Majengo',
        ],
      },
      {
        name: 'Starehe',
        locations: [
          'Pangani',
          'Ziwani/Kariokor',
          'Ngara',
          'Nairobi Central',
          'Landimawe',
        ],
      },
      {
        name: 'Mathare',
        locations: ['Huruma', 'Ngei', 'Mlango Kubwa', 'Kiamaiko', 'Mabatini'],
      },
      {name: 'Njiru', locations: ['Chokaa', 'Kwanjenga', 'Ruai', 'Kamulu']},
    ],
  },
  {
    name: 'Mombasa',
    subcounties: [
      {
        name: 'Changamwe',
        locations: ['Port Reitz', 'Miritini', 'Chaani', 'Jomvu', 'Mikindani'],
      },
      {
        name: 'Likoni',
        locations: ['Shika Adabu', 'Mtongwe', 'Likoni', 'Bofu', 'Timbwani'],
      },
      {
        name: 'Nyali',
        locations: ['Mkomani', 'Wazee', 'Frere Town', 'Kongowea', 'Kisauni'],
      },
      {
        name: 'Kisauni',
        locations: ['Bamburi', 'Mtopanga', 'Magogoni', 'Mjambere', 'Shanzu'],
      },
      {
        name: 'Jomvu',
        locations: [
          'Magongo',
          'Jomvu Kuu',
          'Mikindani',
          'Mwakirunge',
          'Mwamlai',
        ],
      },
      {
        name: 'Mvita',
        locations: ['Tudor', 'Tononoka', 'Makadara', 'Kizingo', 'Central'],
      },
    ],
  },
  {
    name: 'Kwale',
    subcounties: [
      {
        name: 'Matuga',
        locations: [
          'Mwavumbo',
          'Kikoneni',
          'Tsimba Golini',
          'Waa',
          "Ng'ombeni",
          'Tiwi',
        ],
      },
      {
        name: 'Msambweni',
        locations: [
          'Gombato Bongwe',
          'Ukunda',
          'Kinondo',
          'Ramisi',
          'Diani',
          'Msambweni',
        ],
      },
      {
        name: 'Lungalunga',
        locations: [
          'Vanga',
          'Shimba Hills',
          'Mackinnon Road',
          'Lungalunga',
          'Pongwe/Kikoneni',
        ],
      },
      {
        name: 'Kinango',
        locations: ['Kinango', 'Kasemeni', 'Ndavaya', 'Mwavumbo', 'Puma'],
      },
    ],
  },
  {
    name: 'Kilifi',
    subcounties: [
      {
        name: 'Kilifi North',
        locations: [
          'Tezo',
          'Matsangoni',
          'Kikambala',
          'Kayafungo',
          'Watamu',
          'Junju',
        ],
      },
      {
        name: 'Kilifi South',
        locations: [
          'Shimo la Tewa',
          'Takaungu',
          'Mtwapa',
          'Didawe/Mriaria',
          'Chasimba',
        ],
      },
      {name: 'Ganze', locations: ['Ganze', 'Bambala', 'Jaribuni', 'Sokoke']},
      {
        name: 'Malindi',
        locations: ['Malindi Town', 'Jilore', 'Kakuyuni', 'Watamu', 'Ganda'],
      },
      {
        name: 'Magarini',
        locations: ['Magarini', 'Marafa', 'Gongoni', 'Sabaki'],
      },
      {name: 'Rabai', locations: ['Rabai/Kambe', 'Mwawesa', 'Kaloleni']},
      {
        name: 'Kaloleni',
        locations: ['Mariakani', 'Kayafungo', 'Mwanamwinga', 'Kinani'],
      },
    ],
  },
  {
    name: 'Tana River',
    subcounties: [
      {
        name: 'Garsen',
        locations: [
          'Kipini',
          'Kipini East',
          'Chewani',
          'Garsen Central',
          'Garsen West',
          'Garsen South',
        ],
      },
      {
        name: 'Galole',
        locations: [
          'Sala',
          'Kinakomba',
          'Mikinduni',
          'Wayu',
          'Boza',
          'Tana Delta',
        ],
      },
      {
        name: 'Bura',
        locations: ['Bura East', 'Bura West', 'Bangale', 'Madogo'],
      },
    ],
  },
  {
    name: 'Lamu',
    subcounties: [
      {
        name: 'Lamu East',
        locations: [
          'Faza',
          'Kiunga',
          'Basuba',
          'Tangawanda',
          'Shella',
          'Mkomani',
        ],
      },
      {
        name: 'Lamu West',
        locations: ['Shella', 'Mokowe', 'Hindi', 'Mpeketoni', 'Witu', 'Kipini'],
      },
    ],
  },
  {
    name: 'Taita-Taveta',
    subcounties: [
      {
        name: 'Taveta',
        locations: ['Chala', 'Mahoo', 'Kimorigo', 'Bomani', 'Mata', 'Njukini'],
      },
      {
        name: 'Wundanyi',
        locations: [
          'Werugha',
          'Wumingu',
          'Mbale',
          'Mwanda/Mgange',
          'Rukanga',
          'Bura',
        ],
      },
      {
        name: 'Mwatate',
        locations: [
          'Mwatate',
          'Ronngo',
          'Boghoyo',
          'Mbololo',
          'Sagalla',
          'Voi',
        ],
      },
    ],
  },
  {
    name: 'Garissa',
    subcounties: [
      {
        name: 'Garissa Township',
        locations: ['Garissa', 'Ijara', 'Masalani', 'Hagadera', 'Dadaab'],
      },
      {
        name: 'Dadaab',
        locations: ['Dadaab', 'Labisigale', 'Damajale', 'Fafi', 'Balambala'],
      },
      {
        name: 'Fafi',
        locations: ['Bura', 'Dekaharis', 'Jarajila', 'Fafi', 'Hulugho'],
      },
      {
        name: 'Balambala',
        locations: ['Balambala', 'Danyere', 'Garissa', 'Saka', 'Iftin'],
      },
      {
        name: 'Lagdera',
        locations: ['Modogashe', 'Benane', 'Dadaab', 'Liboi', 'Alinjugur'],
      },
      {
        name: 'Hulugho',
        locations: ['Hulugho', 'Ijara', 'Sangailu', 'Masalani'],
      },
    ],
  },
  {
    name: 'Wajir',
    subcounties: [
      {
        name: 'Wajir North',
        locations: ['Buna', 'Wajir Bor', 'Griftu', 'Hadado', 'Gurar'],
      },
      {
        name: 'Wajir East',
        locations: ['Wajir', 'Tarbaj', 'Habaswein', 'Khorof Harar', 'Sarman'],
      },
      {
        name: 'Wajir West',
        locations: ['Ademasajida', 'Arbajahan', 'Gurar', 'Wagberi', 'Bute'],
      },
      {
        name: 'Wajir South',
        locations: [
          'Lagboghol North',
          'Lagboghol South',
          'Benane',
          'Habaswein',
        ],
      },
      {name: 'Tarbaj', locations: ['Tarbaj', 'Wargadud', 'Sarman', 'Godoma']},
      {name: 'Eldas', locations: ['Eldas', 'Dambas', 'Lakole', 'Elkoba']},
    ],
  },
  {
    name: 'Mandera',
    subcounties: [
      {
        name: 'Mandera North',
        locations: [
          'Elwak',
          'Lafey',
          'Warankara',
          'Shimbir Fatuma',
          'Khalalio',
        ],
      },
      {
        name: 'Mandera West',
        locations: ['Takaba', 'Dandu', 'Gither', 'Banisa', 'Kutulo'],
      },
      {
        name: 'Mandera Central',
        locations: ['Mandera Town', 'Township', 'Neboi', 'Sera'],
      },
      {
        name: 'Mandera East',
        locations: ['Arabia', 'Ashabito', 'Wargudud', 'Fino', 'Omar Jirrow'],
      },
      {
        name: 'Banissa',
        locations: ['Banissa', 'Derkhale', 'Guba', 'Malkamari', 'Khorof Harar'],
      },
      {
        name: 'Lafey',
        locations: ['Lafey', 'Alungo', 'Damasa', 'Farasani', 'Waranqara'],
      },
    ],
  },
  {
    name: 'Marsabit',
    subcounties: [
      {
        name: 'Moyale',
        locations: ['Moyale', 'Butiye', 'Sololo', 'Uran', 'Golbo'],
      },
      {
        name: 'Marsabit Central',
        locations: ['Marsabit', 'Karare', 'Manyatta', 'Log-logo', 'Shurr'],
      },
      {
        name: 'Laisamis',
        locations: ['Laisamis', 'Korr', 'Loiyangalani', 'Kargi'],
      },
      {
        name: 'North Horr',
        locations: ['Illeret', 'Dukana', 'Turbi', 'North Horr'],
      },
    ],
  },
  {
    name: 'Isiolo',
    subcounties: [
      {
        name: 'Isiolo North',
        locations: [
          'Isiolo',
          'Garbatulla',
          'Sericho',
          'Ngaremara',
          'Oldonyiro',
        ],
      },
      {
        name: 'Isiolo South',
        locations: ['Merti', 'Garba Tula', 'Kinna', 'Burat', 'Chari'],
      },
    ],
  },
  {
    name: 'Meru',
    subcounties: [
      {
        name: 'Imenti North',
        locations: [
          'Maua',
          'Laare',
          'Mitunguu',
          'Timau',
          'Nchiru',
          'Antuambui',
        ],
      },
      {
        name: 'Imenti South',
        locations: [
          'Nkubu',
          'Muthara',
          'Kianjai',
          'Mwimbi',
          'Igoji East',
          'Igoji West',
        ],
      },
      {
        name: 'Imenti Central',
        locations: [
          'Meru Town',
          'Kiirua/Naari',
          'Abogeta East',
          'Abogeta West',
          'Mwanganthia',
        ],
      },
      {
        name: 'Tigania East',
        locations: ['Kianjai', 'Tharaka', 'Mikinduri', 'Muthara'],
      },
      {
        name: 'Tigania West',
        locations: ['Akithii', 'Kibirichia', 'Athwana', 'Nkomo'],
      },
      {name: 'Igembe South', locations: ['Maua', 'Njia', 'Kangeta', 'Amwathi']},
      {
        name: 'Igembe North',
        locations: ['Antubetwe Kiongo', 'Ntunene', 'Igembe North'],
      },
      {name: 'Buuri', locations: ['Timau', 'Kisima', 'Ngare Ndare', 'Mutuati']},
    ],
  },
  {
    name: 'Tharaka-Nithi',
    subcounties: [
      {
        name: 'Tharaka South',
        locations: ['Marimanti', 'Chiakariga', 'Mugwe', 'Gatunga', 'Kamagutuu'],
      },
      {
        name: 'Tharaka North',
        locations: [
          'Gatunga',
          'Mukothima',
          'Nkondi',
          "Igambang'ombe",
          'Tunyai',
        ],
      },
      {name: 'Maara', locations: ['Chogoria', 'Mwimbi', 'Githiomi', 'Mitheru']},
    ],
  },
  {
    name: 'Embu',
    subcounties: [
      {
        name: 'Embu North',
        locations: ['Manyatta', 'Runyenjes', 'Siakago', 'Central', 'Muminji'],
      },
      {
        name: 'Embu South',
        locations: ['Kevote', 'Gachoka', 'Mavuria', 'Makima', 'Nthawa'],
      },
      {
        name: 'Mbeere South',
        locations: ['Evurore', 'Makima', 'Mwea', 'Gachoka'],
      },
      {
        name: 'Mbeere North',
        locations: ['Siakago', 'Nthawa', 'Muminji', 'Nginda'],
      },
    ],
  },
  {
    name: 'Kitui',
    subcounties: [
      {
        name: 'Kitui West',
        locations: ['Kitui', 'Mutomo', 'Ikutha', 'Kabati', 'Kauwi'],
      },
      {
        name: 'Kitui Central',
        locations: [
          'Kisasi',
          'Kwa Vonza',
          'Endau',
          'Tseikuru',
          'Mutitu/Kaliku',
        ],
      },
      {
        name: 'Kitui East',
        locations: [
          'Zombe/Mwitika',
          'Nzambani',
          'Mwingi Central',
          'Tharaka',
          'Waita',
        ],
      },
      {
        name: 'Mwingi North',
        locations: ['Kyuso', 'Mumoni', 'Ngomeni', 'Kithioko'],
      },
      {
        name: 'Mwingi West',
        locations: ['Migwani', 'Nguu/Masumba', 'Thitani', 'Kivou'],
      },
      {
        name: 'Kitui South',
        locations: ['Mutomo', 'Ikanga/Kyome', 'Kanziko', 'Athi'],
      },
    ],
  },
  {
    name: 'Machakos',
    subcounties: [
      {
        name: 'Machakos Town',
        locations: ['Machakos', 'Mumbuni', 'Mutitini', 'Mavoko', 'Kalama'],
      },
      {
        name: 'Mwala',
        locations: ['Mwala', 'Masii', 'Mbiuni', 'Makindu', 'Kithimani'],
      },
      {
        name: 'Kathiani',
        locations: [
          'Kathiani',
          'Mitaboni',
          'Kangundo',
          'Matungulu East',
          'Matungulu West',
        ],
      },
      {name: 'Kangundo', locations: ['Kangundo', 'Tala', 'Koma', 'Ndalani']},
      {
        name: 'Mavoko',
        locations: ['Athi River', 'Syokimau', 'Mlolongo', 'Kinanie'],
      },
      {name: 'Matungulu', locations: ['Kyelengwa', 'Ndalani', 'Kithimani']},
      {name: 'Yatta', locations: ['Kithimani', 'Katangi', 'Matuu', 'Ndithini']},
      {name: 'Ekalakala', locations: ['Ekalakala', 'Kangundo', 'Masinga']},
    ],
  },
  {
    name: 'Makueni',
    subcounties: [
      {
        name: 'Makueni',
        locations: ['Wote', 'Kathonzweni', 'Kilungu', 'Kee', 'Nziu'],
      },
      {
        name: 'Kibwezi',
        locations: [
          'Kibwezi',
          'Mtito Andei',
          'Masongaleni',
          'Makindu',
          'Kambu',
        ],
      },
      {name: 'Kaiti', locations: ['Ukia', 'Ilima', 'Kalamba', 'Kitundu']},
      {name: 'Kilome', locations: ['Mukaa', 'Kasikeu', 'Watema']},
      {name: 'Emali', locations: ['Emali', 'Kalamba', 'Nziu']},
      {
        name: 'Nzaui',
        locations: ['Mbooni', 'Kithungo/Kitundu', 'Kisau/Kiteta'],
      },
    ],
  },
  {
    name: 'Nyandarua',
    subcounties: [
      {
        name: 'Ol Kalou',
        locations: ['Ol Kalou', 'Kinangop', 'Kipipiri', 'Gathanji', 'Rurii'],
      },
      {
        name: 'Ndaragwa',
        locations: ['Ndaragwa', 'Kiriita', 'Leshau', 'Mwihoti'],
      },
      {
        name: 'Kinangop',
        locations: ['Engineer', 'Gatimu', 'North Kinangop', 'South Kinangop'],
      },
      {name: 'Kipipiri', locations: ['Kipipiri', 'Geta', 'Wanjohi']},
      {name: 'Mirangine', locations: ['Mirangine', 'Weru', 'Githabai']},
    ],
  },
  {
    name: 'Nyeri',
    subcounties: [
      {
        name: 'Nyeri Town',
        locations: ['Nyeri', 'Ruringu', 'Kamakwa', 'Gatitu/Muruguru', 'Rware'],
      },
      {
        name: 'Tetu',
        locations: ['Dedan Kimathi', 'Wamagana', 'Aguthi', 'Chinga'],
      },
      {
        name: 'Kieni East',
        locations: [
          'Naromoru/Kiamathaga',
          'Gatarakwa',
          'Mwiyogo/Kinyogori',
          'Naro Moru',
        ],
      },
      {
        name: 'Kieni West',
        locations: ['Mweiga', 'Gikondi', 'Mugunda', 'Kabaru'],
      },
      {
        name: 'Mathira',
        locations: ['Ruguru/Mathira', 'Konyu', 'Iriaini', 'Magutu'],
      },
      {name: 'Othaya', locations: ['Mahiga', 'Kanyange', 'Karima', 'Kiiru']},
      {name: 'Mukuruweini', locations: ['Gikanga', 'Rugi', 'Muhito']},
      {
        name: 'Mukurwe-ini',
        locations: ['Rugi', 'Gakanga', 'Kagumoini', 'Kamburaini'],
      },
    ],
  },
  {
    name: 'Kirinyaga',
    subcounties: [
      {
        name: 'Kirinyaga Central',
        locations: ['Kerugoya', 'Kutus', 'Kagio', 'Mutira', 'Kabare'],
      },
      {
        name: 'Mwea',
        locations: [
          'Wanguru',
          'Makima',
          'Thiba',
          'Gathigiriri',
          'Nyangati',
          'Kangai',
        ],
      },
      {name: 'Ndia', locations: ['Kariti', 'Kiine', 'Mukure', 'Sagana']},
      {
        name: 'Gichugu',
        locations: ['Kianyaga', 'Ngariama', 'Baragwi', 'Kabinga'],
      },
    ],
  },
  {
    name: 'Muranga',
    subcounties: [
      {
        name: 'Kandara',
        locations: ['Kandara', 'Gatanga', 'Kigumo', 'Kangare', 'Muruka'],
      },
      {
        name: 'Kangema',
        locations: ['Kangema', 'Kiharu', 'Kahuro', 'Muguru', 'Gaturi'],
      },
      {
        name: 'Mathioya',
        locations: ['Kiriaini', 'Gitugi', 'Kagumoini', 'Ithanga'],
      },
      {
        name: 'Kiharu',
        locations: ['Mugoiri', 'Wangu', 'Weithaga', 'Murarandia', 'Iyego'],
      },
      {
        name: 'Maragua',
        locations: ['Kimorori/Wempa', 'Makuyu', 'Kamahuha', 'Kambiti'],
      },
      {name: 'Gatanga', locations: ['Kakuzi', 'Njema', 'Avocado', 'Kinyona']},
      {name: 'Kigumo', locations: ['Kigumo', 'Kahumbu', 'Mwimuto', 'Githembe']},
      {name: 'Usalala', locations: ['Usalala', 'Kinyona', 'Makuyu']},
    ],
  },
  {
    name: 'Kiambu',
    subcounties: [
      {
        name: 'Kiambu',
        locations: ['Kiambu', 'Githunguri', 'Kikuyu', 'Kabete', 'Limuru'],
      },
      {
        name: 'Thika',
        locations: ['Thika', 'Gatundu', 'Ruiru', 'Juja', 'Githurai'],
      },
      {
        name: 'Gatundu South',
        locations: ['Kiamwangi', 'Kiganjo', 'Ndarugu', 'Kinyatta'],
      },
      {
        name: 'Gatundu North',
        locations: ['Kairi', "Mang'u", 'Gituamba', 'Ikinu'],
      },
      {name: 'Juja', locations: ['Juja', 'Witeithie', 'Kalimoni', 'Theta']},
      {
        name: 'Ruiru',
        locations: ['Ruiru', 'Kiuu', 'Mwihoko', 'Gitothua', 'Kahawa West'],
      },
      {
        name: 'Limuru',
        locations: ['Limuru Central', 'Ndeiya', 'Lari', 'Tigoni'],
      },
      {name: 'Kikuyu', locations: ['Kikuyu', 'Karai', 'Sigona', 'Kinoo']},
      {name: 'Kabete', locations: ['Wangige', 'Uthiru', 'Muguga', 'Nyathuna']},
      {
        name: 'Githunguri',
        locations: ['Githunguri', 'Ikinu', 'Ngewa', 'Kamburu'],
      },
      {name: 'Lari', locations: ['Kirenga', 'Kimende', 'Kijabe', 'Nyanduma']},
      {
        name: 'Kiambaa',
        locations: ['Cianda', 'Karuri', 'Ndenderu', 'Muchatha'],
      },
    ],
  },
  {
    name: 'Turkana',
    subcounties: [
      {
        name: 'Turkana Central',
        locations: ['Lodwar', 'Kanamkemer', 'Kalokol', 'Kerio', "Kang'atotha"],
      },
      {
        name: 'Turkana North',
        locations: ['Kakuma', 'Lokichoggio', 'Lokitaung', 'Nakiria', 'Kibish'],
      },
      {
        name: 'Turkana South',
        locations: ['Lokichar', 'Katilu', 'Kapedo', 'Turkana South'],
      },
      {
        name: 'Turkana West',
        locations: ["Lokichang'a", 'Kalobeyei', 'Nanaam', "Kang'irita"],
      },
      {name: 'Loima', locations: ['Kotaruk', 'Lokiriama/Lorengelup', 'Loima']},
      {name: 'Kibish', locations: ['Kibish', 'Nakiria']},
    ],
  },
  {
    name: 'West Pokot',
    subcounties: [
      {
        name: 'Kapenguria',
        locations: ['Kapenguria', 'Sook', 'Mnagei', 'Riwo', 'Sina'],
      },
      {
        name: 'Pokot South',
        locations: ['Kacheliba', 'Sigor', 'Lelan', 'Tapach', 'Alale'],
      },
      {name: 'Pokot Central', locations: ['Chepareria', 'Batei', 'Weiwei']},
    ],
  },
  {
    name: 'Samburu',
    subcounties: [
      {
        name: 'Samburu North',
        locations: ['Baragoi', 'Wamba', 'Waso', 'El Barta', 'Nyiro'],
      },
      {
        name: 'Samburu East',
        locations: [
          'Archers Post',
          'Ngare Mara',
          'Lorroki',
          'Maralal',
          'Kirisia',
        ],
      },
      {
        name: 'Samburu West',
        locations: ['Suguta Marmar', 'Lodokejek', 'Porro', 'Sereolupi'],
      },
    ],
  },
  {
    name: 'Trans Nzoia',
    subcounties: [
      {
        name: 'Kiminini',
        locations: ['Kiminini', 'Waitaluk', 'Sirende', 'Tuwan', 'Nabiswa'],
      },
      {name: 'Saboti', locations: ['Saboti', 'Kinyoro', 'Matisi', 'Endebess']},
      {name: 'Endebess', locations: ['Endebess', 'Chepchoina', 'Kaplamai']},
      {
        name: 'Kwanza',
        locations: ['Kwanza', 'Bidii', 'Keiyo', 'Chepsiro/Kiptenden'],
      },
      {
        name: 'Cherangany',
        locations: ['Sinyerere', 'Makutano', 'Kapchemutwa', 'Mutua'],
      },
    ],
  },
  {
    name: 'Uasin Gishu',
    subcounties: [
      {
        name: 'Ainabkoi',
        locations: ['Ainabkoi', 'Kapseret', 'Kesses', 'Moiben', 'Soy'],
      },
      {name: 'Soy', locations: ['Soy', 'Ziwa', 'Moiben', 'Kuinet/Kapsuswa']},
      {
        name: 'Moiben',
        locations: ['Moiben', 'Sergoit', 'Tembelio', 'Karuna/Kipkenyo'],
      },
      {
        name: 'Kesses',
        locations: [
          'Cheptiret/Kipchamo',
          'Racecourse',
          'Tulwet/Chuiyat',
          'Ngenyilel',
        ],
      },
      {
        name: 'Kapseret',
        locations: ['Ngenyilel', 'Langas', 'Megun', 'Kipkenyo/Simat'],
      },
      {name: 'Turbo', locations: ['Kiplombe', 'Ndalat', 'Tapsagoi', 'Kamagut']},
    ],
  },
  {
    name: 'Elgeyo-Marakwet',
    subcounties: [
      {
        name: 'Keiyo North',
        locations: ['Iten', 'Tambach', 'Chepkorio', 'Emsoo', 'Kapchemutwa'],
      },
      {
        name: 'Marakwet East',
        locations: ['Kapyego', 'Chesoi', 'Kapsowar', 'Sambirir', 'Endo'],
      },
      {
        name: 'Marakwet West',
        locations: ['Lelan', 'Sengwer', 'Kerkoroch', 'Moiben/Kuserwo', 'Talai'],
      },
      {
        name: 'Keiyo South',
        locations: ['Kaptarakwa', 'Chepkoyo', 'Metkei', 'Soy South'],
      },
    ],
  },
  {
    name: 'Nandi',
    subcounties: [
      {
        name: 'Chesumei',
        locations: [
          'Kapsabet',
          'Chepkumia',
          'Kilibwoni',
          'Nandi Hills',
          'Mosop',
        ],
      },
      {
        name: 'Emgwen',
        locations: ['Mosoriot', 'Kaptumo', 'Kaptel', "Chemundu/Kapng'etuny"],
      },
      {
        name: 'Mosop',
        locations: [
          'Kurgung/Surungai',
          'Kipkaren/Kagasik',
          'Cheptuiyo',
          'Kabiyet',
        ],
      },
      {
        name: 'Nandi Hills',
        locations: ['Nandi Hills', 'Kabon/Kapsasur', 'Chepterwai'],
      },
      {
        name: 'Aldai',
        locations: ['Kobujoi', 'Koyo/Ndurio', 'Terik', 'Kemeloi/Maraba'],
      },
      {
        name: 'Tindiret',
        locations: [
          'Tindiret',
          "Chepcholoch/Kimong'or",
          'Songor/Soba',
          'Kapsoo',
        ],
      },
    ],
  },
  {
    name: 'Baringo',
    subcounties: [
      {
        name: 'Baringo Central',
        locations: ['Kabarnet', 'Sacho', 'Emining', 'Tenges', 'Lekwaptan'],
      },
      {
        name: 'Baringo North',
        locations: [
          'Kabartonjo',
          'Bartabwa',
          'Barwessa',
          'Saimo/Soi',
          'Tangulbei/Korossi',
        ],
      },
      {
        name: 'Baringo South',
        locations: ['Marigat', 'Ilchamus', 'Mukutani', 'Mochongoi'],
      },
      {
        name: 'Tiaty East',
        locations: ['Kolowa', 'Silale', 'Tangulbei', 'Churo/Amaya'],
      },
      {name: 'Tiaty West', locations: ['Tirioko', 'Kapedo', 'Lomut']},
      {
        name: 'Mogotio',
        locations: ['Mogotio', 'Eldama Ravine', 'Kampi Ya Moto'],
      },
    ],
  },
  {
    name: 'Laikipia',
    subcounties: [
      {
        name: 'Laikipia East',
        locations: ['Nanyuki', 'Rumuruti', 'Ngobit', 'Tigithi', 'Thingithu'],
      },
      {
        name: 'Laikipia North',
        locations: ['Nyahururu', 'Ol Moran', 'Mukogodo', 'Dol Dol', 'Segera'],
      },
      {
        name: 'Laikipia West',
        locations: ['Nyahururu', 'Marmanet', 'Salama', 'Githiga', 'Igwamiti'],
      },
    ],
  },
  {
    name: 'Nakuru',
    subcounties: [
      {
        name: 'Nakuru Town East',
        locations: [
          'Nakuru',
          'Kivumbini',
          'Flamingo',
          'Biashara',
          'Nakuru East',
        ],
      },
      {
        name: 'Naivasha',
        locations: ['Naivasha', 'Mai Mahiu', 'Gilgil', 'Olkaria', 'Lake View'],
      },
      {name: 'Gilgil', locations: ['Gilgil', 'Elementaita', 'Mbaruk/Eburu']},
      {name: 'Kuresoi South', locations: ['Keringet', 'Amalo', 'Kiptagich']},
      {name: 'Kuresoi North', locations: ['Kuresoi', 'Kamara', 'Bahati']},
      {name: 'Molo', locations: ['Molo', 'Turi', 'Elburgon', 'Njoro']},
      {name: 'Njoro', locations: ['Njoro', 'Mau Narok', 'Likia']},
      {name: 'Bahati', locations: ['Bahati', 'Kiamaina', 'Dundori']},
      {name: 'Subukia', locations: ['Subukia', 'Wamunyu', 'Kabazi']},
      {name: 'Rongai', locations: ['Rongai', 'Menengai East', 'Soi']},
      {name: 'London', locations: ['London', 'Nakuru West', 'Kaptembwa']},
    ],
  },
  {
    name: 'Narok',
    subcounties: [
      {
        name: 'Narok North',
        locations: ['Narok', 'Ololulunga', 'Majimoto', 'Nkareta', 'Sogoo'],
      },
      {
        name: 'Narok South',
        locations: [
          'Kilgoris',
          'Emurua Dikirr',
          'Nkareta',
          'Lolgorian',
          'Shankoe',
        ],
      },
      {name: 'Narok East', locations: ['Suswa', 'Mosiro', 'Ewaso Kedong']},
      {name: 'Narok West', locations: ['Mara', 'Loita', 'Olokurto']},
      {name: 'Transmara East', locations: ['Lolgorian', 'Keiyan', 'Olosurua']},
      {name: 'Transmara West', locations: ['Kilgoris', 'Ntimaru', 'Mogondo']},
    ],
  },
  {
    name: 'Kajiado',
    subcounties: [
      {
        name: 'Kajiado North',
        locations: [
          'Ngong',
          'Ongata Rongai',
          'Kiserian',
          'Oloolua',
          'Nkaimurunya',
        ],
      },
      {
        name: 'Kajiado Central',
        locations: [
          'Kajiado',
          'Kitengela',
          'Oloitokitok',
          'Matapato North',
          'Ildamat',
        ],
      },
      {
        name: 'Kajiado South',
        locations: ['Loitokitok', 'Kimana', 'Rombo', 'Kuku', 'Eselenkei'],
      },
      {
        name: 'Kajiado East',
        locations: [
          'Kitengela',
          'Oloosuyian',
          'Kaputiei North',
          'Kaputiei South',
        ],
      },
      {
        name: 'Mashuuru',
        locations: ['Mashuuru', 'Kenyawa/Poka', 'Olgilai/Kimintet'],
      },
    ],
  },
  {
    name: 'Kericho',
    subcounties: [
      {
        name: 'Kericho',
        locations: ['Kericho', 'Litein', 'Kipkelion', 'Ainamoi', 'Belgut'],
      },
      {
        name: 'Bureti',
        locations: ['Sotik', 'Cheborge', 'Kapkatet', 'Tebesonik', 'Kisiara'],
      },
      {
        name: 'Belgut',
        locations: ['Kabianga', 'Kiptere', 'Waldai', 'Cheptororiet/Seretut'],
      },
      {
        name: 'Ainamoi',
        locations: ['Kapsoit', 'Kapkugerwet', 'Kipchebor', 'Cheboin'],
      },
      {
        name: 'Kipkelion East',
        locations: ['Kedowa/Kimugul', 'Chemosot', 'Kipkelion'],
      },
      {name: 'Kipkelion West', locations: ['Kuresoi', 'Kipkelion West']},
    ],
  },
  {
    name: 'Bomet',
    subcounties: [
      {
        name: 'Bomet Central',
        locations: ['Bomet', 'Chepalungu', 'Sotik', 'Konoin', 'Teso'],
      },
      {
        name: 'Chepalungu',
        locations: ['Chepalungu', 'Siongiroi', 'Longisa', 'Ndanai', 'Sigor'],
      },
      {name: 'Konoin', locations: ['Sotik', 'Chebunyo', 'Kimulot', 'Boito']},
      {
        name: 'Sotik',
        locations: ['Sotik', 'Ndanai', 'Manaret', 'Rongena/Manche'],
      },
      {
        name: 'Teso South',
        locations: [
          'Chakol South',
          'Chakol North',
          'Amukura East',
          'Amukura West',
        ],
      },
    ],
  },
  {
    name: 'Kakamega',
    subcounties: [
      {
        name: 'Kakamega Central',
        locations: [
          'Kakamega',
          'Lurambi',
          'Shinyalu',
          'Navakholo',
          'Ikolomani',
        ],
      },
      {
        name: 'Lugari',
        locations: ['Lugari', 'Likuyani', 'Matete', 'Malava', 'Mumias East'],
      },
      {name: 'Likuyani', locations: ['Likuyani', 'Soy', 'Kongoni']},
      {name: 'Malava', locations: ['Malava', 'East Kabras', 'West Kabras']},
      {
        name: 'Mumias East',
        locations: ['Mumias Central', 'Lusheya/Mundeku', 'Etenje'],
      },
      {name: 'Mumias West', locations: ['Mumias West', 'Musanda', 'Mayoni']},
      {name: 'Matungu', locations: ['Koyonzo', 'Osingo', 'Kholera']},
      {
        name: 'Butere',
        locations: [
          'Marama North',
          'Marama Central',
          'Marama South',
          'Shianda',
        ],
      },
      {
        name: 'Khwisero',
        locations: ['Khwisero', 'Kisa Central', 'Kisa East', 'Kisa West'],
      },
      {
        name: 'Ikolomani',
        locations: [
          'Shinyalu',
          'Mahiakalo',
          'Idakho North',
          'Idakho Central',
          'Idakho South',
        ],
      },
      {
        name: 'Shinyalu',
        locations: ['Isukha Central', 'Isukha East', 'Isukha West', 'Murhanda'],
      },
      {
        name: 'Navakholo',
        locations: [
          'Navakholo',
          'Ingostse/Mathari',
          'Esumeyia',
          'Bunyala West',
        ],
      },
    ],
  },
  {
    name: 'Vihiga',
    subcounties: [
      {
        name: 'Vihiga',
        locations: [
          'Mbale',
          'Luanda',
          'Wodanga',
          'Central Maragoli',
          'West Maragoli',
        ],
      },
      {
        name: 'Sabatia',
        locations: [
          'Sabatia',
          'Chavakali',
          'Lyaduywa',
          'Busali',
          'North Maragoli',
        ],
      },
      {
        name: 'Hamisi',
        locations: ['Shiru', 'Muhudu', 'Shaviringa', 'Jepkoyai'],
      },
      {
        name: 'Luanda',
        locations: ['Luanda Township', 'Emuhaya', 'Manyatta', 'Mwibona'],
      },
      {
        name: 'Emuhaya',
        locations: [
          'Emuhaya',
          'Central Bunyore',
          'North East Bunyore',
          'West Bunyore',
        ],
      },
    ],
  },
  {
    name: 'Bungoma',
    subcounties: [
      {
        name: 'Bungoma North',
        locations: ['Bungoma', 'Webuye', 'Bokoli', 'Kanduyi', 'Kimilili'],
      },
      {
        name: 'Bungoma South',
        locations: ['Chwele', 'Kanduyi', 'Naitiri', 'Tongaren', 'Sirisia'],
      },
      {name: 'Webuye East', locations: ['Mihuu', 'Nambacha', 'Misikhu']},
      {
        name: 'Webuye West',
        locations: ['Bukhayo East', 'Bukhayo West', 'Malaha/Mbakalo'],
      },
      {name: 'Kimilili', locations: ['Kimilili', 'Kimaswa', 'Kamukuywa']},
      {name: 'Mt Elgon', locations: ['Chesikaki', 'Cheptais', 'Kapsokwony']},
      {
        name: 'Kanduyi',
        locations: ['Bukembe West', 'Bukembe East', 'Township', 'Musikoma'],
      },
      {
        name: 'Tongaren',
        locations: ['Nabiswa', 'Milima', 'Mbakalo', 'Likuyani'],
      },
      {name: 'Sirisia', locations: ['Namachanja', 'Malaba', 'Lwakhakha']},
    ],
  },
  {
    name: 'Busia',
    subcounties: [
      {
        name: 'Busia',
        locations: [
          'Busia',
          'Nambale',
          'Matayos',
          'Butula',
          'Funyula',
          'Samia',
        ],
      },
      {
        name: 'Teso North',
        locations: ['Malaba', 'Amagoro', 'Angurai', 'Chakol'],
      },
      {name: 'Teso South', locations: ['Amukura', 'Angoromo', 'Adungosi']},
      {
        name: 'Nambale',
        locations: ['Nambale', 'Bukhayo North/Walatsi', 'Bukhayo East'],
      },
      {
        name: 'Butula',
        locations: [
          'Marachi West',
          'Marachi Central',
          'Marachi East',
          'Kingandole',
        ],
      },
      {
        name: 'Funyula',
        locations: ['Namboboto/Nambuku', 'Agenga/Nanguba', 'Budalangi'],
      },
      {
        name: 'Samia',
        locations: ['Nambuku/Namboboto', 'Agenga/Nanguba', 'Port Victoria'],
      },
    ],
  },
  {
    name: 'Siaya',
    subcounties: [
      {
        name: 'Siaya',
        locations: [
          'Siaya',
          'Ugunja',
          'Ukwala',
          'Alego Usonga',
          'Gem',
          'Bondo',
        ],
      },
      {
        name: 'Gem',
        locations: [
          'Yala',
          'Wagai',
          'Sidindi',
          'North Gem',
          'Central Gem',
          'West Gem',
          'South Gem',
        ],
      },
      {
        name: 'Bondo',
        locations: [
          'Bondo',
          'Usigu',
          'West Yimbo',
          'Central Sakwa',
          'East Sakwa',
        ],
      },
      {
        name: 'Rarieda',
        locations: [
          'Rarieda',
          'West Asembo',
          'East Asembo',
          'North Uyoma',
          'South Uyoma',
          'Central Gem',
        ],
      },
      {
        name: 'Ugunja',
        locations: ['Ugunja', 'Sigomere', 'Sidindi/Manyala', 'North Alego'],
      },
      {
        name: 'Alego Usonga',
        locations: [
          'Usonga',
          'Siaya Township',
          'North Alego',
          'Central Alego',
          'West Alego',
          'South East Alego',
        ],
      },
    ],
  },
  {
    name: 'Kisumu',
    subcounties: [
      {
        name: 'Kisumu Central',
        locations: [
          'Kisumu',
          'Kondele',
          'Manyatta',
          'Market Milimani',
          'Central Kisumu',
        ],
      },
      {
        name: 'Kisumu East',
        locations: ['Kisumu East', 'Kajulu', 'Kolwa', 'Nyalenda B', 'Migosi'],
      },
      {
        name: 'Kisumu West',
        locations: [
          'Kisumu West',
          'Maseno',
          'Manyatta B',
          'Railways',
          'Central Seme',
        ],
      },
      {name: 'Seme', locations: ['West Seme', 'Central Seme', 'East Seme']},
      {
        name: 'Nyando',
        locations: ['Chemelil', 'Awasi/Onjiko', 'Kobura', 'Koru/Jatani'],
      },
      {
        name: 'Nyakach',
        locations: [
          'South East Nyakach',
          'West Nyakach',
          'North Nyakach',
          'Central Nyakach',
        ],
      },
      {name: 'Muhoroni', locations: ['Miwa/Kisembe', 'Ombeyi', 'Kendu/Rabuor']},
    ],
  },
  {
    name: 'Homa Bay',
    subcounties: [
      {
        name: 'Homa Bay Town',
        locations: ['Homa Bay', 'Kendu Bay', 'Rangwe', 'Kaberamaido', 'Arujo'],
      },
      {
        name: 'Ndhiwa',
        locations: ['Ndhiwa', 'Kwabwai', 'Kanyadoto', 'Kanyikela', 'Lambwe'],
      },
      {
        name: 'Rangwe',
        locations: [
          'Rangwe',
          'Kochia',
          'East Kamagak',
          'West Kamagak',
          'North Kamagak',
        ],
      },
      {
        name: 'Suba North',
        locations: ['Mbita', 'Mfangano Island', 'Rusinga Island'],
      },
      {
        name: 'Suba South',
        locations: [
          'Gwassi North',
          'Gwassi South',
          'Kaksingiri West',
          'Kaksingiri East',
        ],
      },
      {
        name: 'Karachuonyo',
        locations: [
          'Kibiri',
          'Kendu Bay Town',
          "Wang'chieng'",
          'Kanyaluo',
          'Kokaleka',
        ],
      },
      {
        name: 'Kasipul',
        locations: [
          'Kabondo East',
          'Kabondo West',
          'Kagoro/Kochia',
          'Oyugis Town',
        ],
      },
      {
        name: 'Rachuonyo North',
        locations: [
          'Koyugi North',
          'Koyugi South',
          'East Kamagak',
          'West Kamagak',
        ],
      },
      {
        name: 'Rachuonyo South',
        locations: [
          'West Karachuonyo',
          'East Karachuonyo',
          'Central Karachuonyo',
        ],
      },
    ],
  },
  {
    name: 'Migori',
    subcounties: [
      {
        name: 'Migori',
        locations: [
          'Migori',
          'Kuria East',
          'Kuria West',
          'Rongo',
          'Awendo',
          'Nyatike',
          'Suna East',
          'Suna West',
        ],
      },
      {
        name: 'Rongo',
        locations: [
          'Rongo',
          'Awendo',
          'Kanyaruoto',
          'East Kamagambo',
          'West Kamagambo',
        ],
      },
      {
        name: 'Awendo',
        locations: ['Awendo', 'Sakwa East', 'Sakwa West', 'North Sakwa'],
      },
      {
        name: 'Nyatike',
        locations: ['Muhuru Bay', 'Kuria', 'Macalder/Kongo', 'Kaler'],
      },
      {
        name: 'Kuria East',
        locations: ['Mugirango', 'Ntimaru West', 'Ntimaru East'],
      },
      {name: 'Kuria West', locations: ['Isibania', 'Masaba', 'Tagare']},
      {
        name: 'Suna East',
        locations: ['Kuria', 'God Jope', 'Central Suna', 'Oruba'],
      },
      {
        name: 'Suna West',
        locations: ['Wasweta I', 'Wasweta II', 'Wiga', 'Piny Oyie'],
      },
    ],
  },
  {
    name: 'Kisii',
    subcounties: [
      {
        name: 'Kisii Central',
        locations: [
          'Kisii',
          'Marani',
          'Masimba',
          'Kitutu Central',
          'Kitutu Chache South',
        ],
      },
      {
        name: 'Nyamache',
        locations: ['Nyamache', 'Gesusu', 'Bogiakumu', 'Bonchari'],
      },
      {
        name: 'Kitutu Chache North',
        locations: ['Monyerero', 'Nyaribari Chache', 'Nyaribari Masaba'],
      },
      {
        name: 'Kitutu Chache South',
        locations: ['Bogeka', 'Nyakoe', ' বোয়ানাছি'],
      },
      {
        name: 'Bonchari',
        locations: ['Bomorenda', 'Riana', 'Bogiakumu', 'Bomariba'],
      },
      {
        name: 'South Mugirango',
        locations: ['Tabaka/Ogembo', 'Kipasi', 'Nyamarambe', ' বোয়ানাছি'],
      },
      {
        name: ' বোয়ানাছি',
        locations: [' বোয়ানাছি', ' বোয়ানাছি', ' বোয়ানাছি', ' বোয়ানাছি'],
      },
      {
        name: 'Nyaribari Masaba',
        locations: [' কিয়ামোনিয়া', ' কিয়াজোঙ্গা', ' ইতান্ডা'],
      },
      {
        name: 'Nyaribari Chache',
        locations: [' কিগওয়ারি', ' কিবিউ', ' কিবরিংে'],
      },
    ],
  },
  {
    name: 'Nyamira',
    subcounties: [
      {
        name: 'Nyamira North',
        locations: ['Nyamira', 'Manga', 'Rigoma', 'Borabu', 'Kitutu Masaba'],
      },
      {
        name: 'Nyamira South',
        locations: ['Nyamira South', 'Ekerenyo', 'Bomorenda', ' বোয়ানাছি'],
      },
      {
        name: 'Borabu',
        locations: [' Nyansiongo', ' Esise', ' Kiogoro', ' বোয়ানাছি'],
      },
      {name: 'Kitutu Masaba', locations: ['Magombo', 'Gesima', ' সমাধান']},
      {name: 'Masaba North', locations: [' ইটাঙ্গারী', ' বোয়ানাছি', ' সমাধান']},
    ],
  },

];

const classes = [
 'PG', 'PP1', 'PP2', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5',
  'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',

];

const InstitutionSignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    schoolName: '',
    schoolCode: '',
    county: '',
    subcounty: '',
    location: '',
    village: '',
    address: '',
    phoneNumber: '',
    email: '',
    website: '',
    maxStreamsPerClass: '1',
  });
  const [streamInputs, setStreamInputs] = useState({});
  const [streamNames, setStreamNames] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    if (name === 'maxStreamsPerClass' && value === '1') {
      setStreamInputs({});
      setStreamNames({});
    }
  };

  const handleStreamInputChange = (className, value) => {
    setStreamInputs(prev => ({
      ...prev,
      [className]: value,
    }));
  };

  const addStream = (className) => {
    if (!streamInputs[className] || !streamInputs[className].trim()) {
      setError(`Please enter a stream name for ${className}`);
      return;
    }
    setStreamNames(prev => ({
      ...prev,
      [className]: [...(prev[className] || []), streamInputs[className].trim()],
    }));
    setStreamInputs(prev => ({
      ...prev,
      [className]: '',
    }));
    setError('');
  };

  const removeStream = (className, index) => {
    setStreamNames(prev => {
      const updated = { ...prev };
      updated[className] = updated[className].filter((_, i) => i !== index);
      if (updated[className].length === 0) {
        delete updated[className];
      }
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const requiredFields = [
      'schoolName', 'schoolCode', 'county', 'subcounty', 'location',
      'village', 'address', 'phoneNumber', 'email',
    ];
    if (requiredFields.some(field => !formData[field])) {
      setError('Please fill in all required fields.');
      setIsLoading(false);
      return;
    }

    const classStreamsData = {};
    if (formData.maxStreamsPerClass > 1) {
      for (const className in streamNames) {
        if (streamNames[className].length > 0) {
          classStreamsData[className] = streamNames[className];
        }
      }
    }

    const payload = {
      ...formData,
      maxStreamsPerClass: Number(formData.maxStreamsPerClass),
      classStreams: classStreamsData,
    };

    try {
      const response = await axios.post('https://kidsm.vercel.app/api/schools/register', payload);
      if (response.data) {
        alert('School registered successfully! Please check your email to activate your account.');
        navigate('/login');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const availableSubcounties = countiesData.find(c => c.name === formData.county)?.subcounties || [];
  const availableLocations = availableSubcounties.find(sc => sc.name === formData.subcounty)?.locations || [];

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          School Registration
        </Typography>
        
        {error && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="School Name"
            name="schoolName"
            value={formData.schoolName}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="School Code"
            name="schoolCode"
            value={formData.schoolCode}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            select
            fullWidth
            label="County"
            name="county"
            value={formData.county}
            onChange={handleChange}
            margin="normal"
            required
          >
            <MenuItem value="">Select County</MenuItem>
            {countiesData.map((county) => (
              <MenuItem key={county.name} value={county.name}>
                {county.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            label="Subcounty"
            name="subcounty"
            value={formData.subcounty}
            onChange={handleChange}
            margin="normal"
            required
            disabled={!formData.county}
          >
            <MenuItem value="">Select Subcounty</MenuItem>
            {availableSubcounties.map((subcounty) => (
              <MenuItem key={subcounty.name} value={subcounty.name}>
                {subcounty.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            label="Location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            margin="normal"
            required
            disabled={!formData.subcounty}
          >
            <MenuItem value="">Select Location</MenuItem>
            {availableLocations.map((location) => (
              <MenuItem key={location} value={location}>
                {location}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            label="Village"
            name="village"
            value={formData.village}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Official Phone Number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Official Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="School Website (Optional)"
            name="website"
            value={formData.website}
            onChange={handleChange}
            margin="normal"
          />
          <Box sx={{ mt: 3, mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom>
              Class Streams Configuration
            </Typography>
            <FormControl fullWidth margin="normal">
              <InputLabel>Maximum Streams per Class</InputLabel>
              <Select
                name="maxStreamsPerClass"
                value={formData.maxStreamsPerClass}
                onChange={handleChange}
              >
                <MenuItem value="1">1 (No streams)</MenuItem>
                {[...Array(14).keys()].map(i => (
                  <MenuItem key={i + 2} value={i + 2}>{i + 2}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {formData.maxStreamsPerClass > 1 && (
              <Box sx={{ mt: 2 }}>
                {classes.map(className => (
                  <Box key={className} sx={{ mb: 2, p: 2, bgcolor: '#fff', borderRadius: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">{className} Streams</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                      <TextField
                        fullWidth
                        label={`Enter ${className} stream name`}
                        value={streamInputs[className] || ''}
                        onChange={(e) => handleStreamInputChange(className, e.target.value)}
                        sx={{ mr: 1 }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => addStream(className)}
                      >
                        Add
                      </Button>
                    </Box>
                    <List>
                      {streamNames[className]?.map((stream, index) => (
                        <ListItem key={index}>
                          <ListItemText primary={stream} />
                          <ListItemSecondaryAction>
                            <IconButton edge="end" onClick={() => removeStream(className, index)}>
                              <DeleteIcon />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, height: '48px' }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default InstitutionSignup;
